export const PARAMS_NAME = {
    partnerRequests: 'Partner Requests',
    winsPercent: 'Win %',
    partnerRevenues: 'Partner Rev.',
    partnerDiscrepancy: 'Partner Disc. %'
};

export const NAN_PARAMS = {
    day: 1,
    source: 1,
    onw: 1,
    country: 1
};


// WEBPACK FOOTER //
// ./src/scenes/BidderV2/config.js